module.exports = __webpack_public_path__ + "static/media/logo-main.193dd6f3.svg";